import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const resolveStyle = theme => ({
  display: 'flex',
  padding: '12px 16px 12px 0',
  flexDirection: 'column',
  gap: '4px',
  minWidth: '0',
  width: '206px',
  cursor: 'pointer'
});
const resolveTitleStyle = theme => ({
  flex: '1 0 auto',
  overflow: 'hidden',
  color: theme.tokens.SemColorOnSurfaceDefault,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontFamily: theme.tokens.SemTypeFontBody,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '120%',
  flexShrink: '0',
  minWidth: '0'
});
const resolveMessageStyle = theme => ({
  flex: '1 0 auto',
  overflow: 'hidden',
  color: theme.tokens.SemColorOnSurfaceDefault,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontFamily: theme.tokens.SemTypeFontBody,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '130%'
});
/**
 * Represents the content of a toast message.
 *
 * @param {Object} props - The props for the ToastContent component.
 * @param {string} props.title - The title of the toast message.
 * @param {string} props.message - The message of the toast message.
 * @param {function} props.onClick - The function to call when the toast content is clicked.
 * @returns {JSX.Element} - The rendered ToastContent component.
 */
export const ToastContent = props => {
  const theme = useInterstateTheme();
  const style = resolveStyle(theme);
  const titleStyle = resolveTitleStyle(theme);
  const messageStyle = resolveMessageStyle(theme);
  const {
    title,
    message,
    onClick
  } = props;
  return /*#__PURE__*/_jsxs(Box, {
    sx: style,
    className: 'ids-toast-content',
    onClick: onClick,
    children: [title && /*#__PURE__*/_jsx(Box, {
      sx: titleStyle,
      className: 'ids-toast-title',
      children: title
    }), message && /*#__PURE__*/_jsx(Box, {
      sx: messageStyle,
      className: 'ids-toast-message',
      children: message
    })]
  });
};